export default __webpack_public_path__ + "static/media/notify.166e1969.mp3";